//#region Imports
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import "../css/LoginForm.css"
//#endregion
import { useNavigate } from 'react-router-dom';
import "../css/LoginForm.css";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../config/firebase-config";

interface LoginProps {
    BackgroundColor: string;
}

//#region Component
/**
 * LoginForm component that handles user authentication
 * @param Props - Component properties containing background color
 * @returns Login form with username, password and church code inputs
 */
export default function LoginForm(Props: LoginProps) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [churchCode, setChurchCode] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        try {
            const userCredential = await signInWithEmailAndPassword(auth, username, password);
            console.log("Logged in:", userCredential.user);
            navigate("/main")
        } catch (error: any) {
            setErrorMessage("Invalid Username/Password");
            console.error("Login error:", error.message);
        }
    };

    return (
        <Row className="justify-content-center login-main">
            <Col xs={4}>
                <form className="d-flex justify-content-center form" onSubmit={handleSubmit}>
                    <label className="d-flex username-label">Username</label>
                    <input
                        id="username"
                        className="username"
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <label className="d-flex password-label">Password</label>
                    <input
                        id="password"
                        className="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <label className="d-flex church-code-label">Church Code</label>
                    <input
                        id="churchCode"
                        className="church-code"
                        type="text"
                        value={churchCode}
                        onChange={(e) => setChurchCode(e.target.value)}
                    />
                    <button type="submit" className="login-button">Login</button>
                </form>
                {errorMessage && <div className="d-flex justify-content-center error-message">{errorMessage}</div>}
            </Col>
        </Row>
    );
    //#endregion
}
//#endregion